module.exports = "/assets/src/assets/message.svg";